import { render, staticRenderFns } from "./MaintenanceTypeList.vue?vue&type=template&id=438875b3"
import script from "./MaintenanceTypeList.vue?vue&type=script&lang=js"
export * from "./MaintenanceTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports